export default "__VITE_ASSET__65efc280__"